import React from "react";
import { Box, Button, Link } from "@mui/material";

const BackButton = (props) => {
  return (
    <Button
      component={Link}
      size="large"
      {...props}
      startIcon={
        <Box sx={{ rotate: "180deg" }}>
          <svg
            width={16}
            height={16}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </Box>
      }
    ></Button>
  );
};

export default BackButton;
